"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeSelectionModel = void 0;
/**
 * Sanitize a selection model by dropping phantom IDs introduced during data
 * transitions (e.g., page size changes with Apollo's cache-and-network fetch
 * policy where stale rows cause MUI DataGrid to fire onRowSelectionModelChange
 * with extra IDs).
 *
 * Compares the next selection against the previous one. Any newly added ID that
 * is not present in the current valid page set is considered a phantom and removed.
 */
const sanitizeSelectionModel = (nextModel, prevModel, validPageIds) => {
    if (nextModel.type !== 'include' || prevModel.type !== 'include') {
        return nextModel;
    }
    const phantomIds = [];
    for (const id of nextModel.ids) {
        if (!prevModel.ids.has(id) && !validPageIds.has(id)) {
            phantomIds.push(id);
        }
    }
    if (phantomIds.length === 0) {
        return nextModel;
    }
    const sanitizedIds = new Set(nextModel.ids);
    for (const id of phantomIds) {
        sanitizedIds.delete(id);
    }
    return { type: 'include', ids: sanitizedIds };
};
exports.sanitizeSelectionModel = sanitizeSelectionModel;
